import { Button } from "@mui/material";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export interface PageHeaderProps {
  heading?: string;
  subHeading?: string;
  subHeadingComponent?: ReactNode;
  backBtnTitle?: string;
  actionSection?: ReactNode;
  backAction?: () => void;
}

export default function PageHeader({
  heading,
  subHeading,
  actionSection,
  backBtnTitle,
  backAction,
  subHeadingComponent,
}: PageHeaderProps) {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", justifyContent: "space-between", margin: "20px 0px", flexWrap: "wrap" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <span style={{ fontSize: 22, color: "#1a1919" }}>{heading}</span>
        {subHeadingComponent ? (
          subHeadingComponent
        ) : (
          <span style={{ fontSize: "10px", color: "#aeaeae" }}>{subHeading}</span>
        )}
      </div>
      <div>
        {actionSection || (
          <Button
            variant="text"
            style={{ color: "#7D96B8", gap: "10px" }}
            onClick={() => (backAction ? backAction() : navigate(-1))}
          >
            <ArrowBackIcon color="#7D96B8" />
            <span>{backBtnTitle || "بازگشت"}</span>
          </Button>
        )}
      </div>
    </div>
  );
}
